import Enumeration from "../domain/Enumeration";


export const ResponsiveSize = new Enumeration({
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl",
  XXL: "xxl"
});

const getWeight = function (size) {
  if (size === ResponsiveSize.XXL) return 6;
  else if (size === ResponsiveSize.XL) return 5;
  else if (size === ResponsiveSize.LG) return 4;
  else if (size === ResponsiveSize.MD) return 3;
  else if (size === ResponsiveSize.SM) return 2;
  else if (size === ResponsiveSize.XS) return 1;

};

const calculateSize = function (width) {
  /*
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  */
  if (width > 1500) return ResponsiveSize.XXL;
  else if (width > 1200) return ResponsiveSize.XL;
  else if (width > 992) return ResponsiveSize.LG;
  else if (width > 768) return ResponsiveSize.MD;
  else if (width > 576) return ResponsiveSize.SM;
  else return ResponsiveSize.XS;
};

const isSmallerThan = function (checkIfThis, smallerThanThis) {
  let checkWeight = getWeight(checkIfThis);
  let smallerThanWeight = getWeight(smallerThanThis);
  return checkWeight < smallerThanWeight;
};
const isSmallerThanOrEquals = function (checkIfThis, smallerThanThis) {
  let checkWeight = getWeight(checkIfThis);
  let smallerThanWeight = getWeight(smallerThanThis);
  return checkWeight <= smallerThanWeight;
};
const isLargerThan = function (checkIfThis, largerThanThis) {
  let checkWeight = getWeight(checkIfThis);
  let largerThanWeight = getWeight(largerThanThis);
  return checkWeight > largerThanWeight;
};
const isLargerThanOrEquals = function (checkIfThis, largerThanThis) {
  let checkWeight = getWeight(checkIfThis);
  let largerThanWeight = getWeight(largerThanThis);
  return checkWeight >= largerThanWeight;
};

export const ResponsiveHelper = {
  calculateSize,
  isSmallerThan, isSmallerThanOrEquals,
  isLargerThan, isLargerThanOrEquals
};
